"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var BASE_STRING = 'profileContentTimeline.timelineTitle';

function getTimelineItemTitle(timelineItem) {
  var etype = timelineItem.get('etype');
  return BASE_STRING + "." + etype;
}

function getTimelineEngagementTitle(engagement) {
  var engagementType = engagement.getIn(['engagement', 'type']);
  return BASE_STRING + "." + engagementType;
}

var _default = {
  getTimelineItemTitle: getTimelineItemTitle,
  getTimelineEngagementTitle: getTimelineEngagementTitle
};
exports.default = _default;
module.exports = exports.default;